import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TermsAndConditionsComponent } from '@shared/components';
import { PrimeDialogComponent } from '../prime-dialog/prime-dialog.component';

@Component({
  selector: 'terms-dialog',
  standalone: true,
  imports: [
    PrimeDialogComponent,
    TermsAndConditionsComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './terms-and-conditions-dialog.component.html',
  styleUrl: './terms-and-conditions-dialog.component.scss'
})
export class TermsAndConditionsDialogComponent {
  onCloseButton = output<void>();

  visible = input(false);

  breakpoints = input<{ [key: string]: string; }>({ '2000px': '50vw', '900px': '70vw', '575px': '90vw' });
  styles = input<{ [key: string]: string; }>({
    'height': '76dvh',
  })

  onClose() {
    this.onCloseButton.emit();
  }
}
